module.exports = __webpack_public_path__ + "img/ico-instagram.de1c648.svg";